import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { voiceApi } from '../../../services/voiceApi';
import { GreeningVoiceModal } from './GreeningVoiceModal';
import { greeningTalkButtonSx } from './GreeningVoiceControls';
import { VoiceChatReveal } from './voiceChatReveal';
import { activateVoiceSurface, bindVoiceClose } from './voiceSurface';

interface Props {
  agentId: string;
  context: {
    type: string;
    referenceId: string;
  };
  onReveal: (reveal: VoiceChatReveal | null) => void;
}

/** Launcher universal. Sem STT, TTS, agente ou segredo. */
export function ConversarComGreeningButton({ agentId, context, onReveal }: Props) {
  const [enabled, setEnabled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => bindVoiceClose('talk', () => setOpen(false)), []);

  useEffect(() => {
    if (!open) return;
    activateVoiceSurface('talk');
  }, [open]);

  useEffect(() => {
    let cancelled = false;
    voiceApi
      .config()
      .then((cfg) => {
        if (!cancelled) setEnabled(cfg.enabled);
      })
      .catch(() => {
        if (!cancelled) setEnabled(false);
      });
    return () => {
      cancelled = true;
    };
  }, [context.referenceId]);

  if (!enabled || !context.referenceId) return null;

  return (
    <>
      <Button
        variant="contained"
        disableElevation
        onClick={() => setOpen(true)}
        sx={{ ...greeningTalkButtonSx, borderRadius: 999, textTransform: 'none', fontWeight: 700 }}
      >
        Conversar com a Greening.AI
      </Button>
      {open && (
        <GreeningVoiceModal
          open={open}
          onClose={() => setOpen(false)}
          agentId={agentId}
          context={context}
          onReveal={onReveal}
        />
      )}
    </>
  );
}
